import React, { useEffect, useState } from "react"
import { attachEncryptedParam } from "../../utils/helper/encryptedUrl"

interface ProtectedImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
}

export const ProtectedImg = ({ src, ...rest }: ProtectedImgProps) => {
  const [imgSrc, setImgSrc] = useState("")

  useEffect(() => {
    if (!src?.includes("https") || src?.includes("blob")) {
      setImgSrc(src)
      return
    } else {
      setImgSrc(attachEncryptedParam(src))
    }
  }, [src])

  return <img src={imgSrc} {...rest} />
}
